import React from 'react';

const Workflow = (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M22 11.1664H14.5878V3.71487H22V11.1664ZM15.2748 10.4758H21.313V4.40562H15.2748V10.4758Z"
            fill="#80B8EE"
            stroke="#80B8EE"
            stroke-width="0.7"
        />
        <path
            d="M9.41218 11.1664H2V3.71487H9.41218V11.1664ZM2.68701 10.4758H8.72516V4.40562H2.68701V10.4758Z"
            fill="#80B8EE"
            stroke="#80B8EE"
            stroke-width="0.7"
        />
        <path
            d="M22 22H14.5878V14.5485H22V22ZM15.2748 21.3094H21.313V15.2392H15.2748V21.3094Z"
            fill="#80B8EE"
            stroke="#80B8EE"
            stroke-width="0.7"
        />
        <path
            d="M9.77777 7.55556H14.1353V8.24614H9.77777V7.55556Z"
            fill="#80B8EE"
            stroke="#80B8EE"
            stroke-width="0.4"
        />
        <path
            d="M14.2221 18.8417H14.397L14.3971 18.6667L14.3972 17.9775L14.3972 17.8025H14.2222H6.2616V10.8889V10.7139H6.0866H5.33331H5.15831V10.8889V18.6667V18.8417H5.33331H14.2221Z"
            fill="#80B8EE"
            stroke="#80B8EE"
            stroke-width="0.35"
        />
    </svg>
);

export default Workflow;
